var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[(_vm.chartData.labels.length > 0)?_c('Bar',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}}):_c('div',{staticClass:"text-center text-muted py-5"},[_vm._v("جاري تحميل البيانات...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }